import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {get} from 'lodash';
import Highcharts from 'highcharts';

import {getPracticeBasedTitle} from '../utils';
import InlineEdit from "common/InlineEdit";

export default function ({printable}) {

    const me = useSelector(state => state.me);
    const dashboard = useSelector(state => state.insights_dashboard);
    const dashboard_data = useSelector(state => state.dashboard_data);
    const [title, setTitle] = useState('');

    const graph_id = 'pam-skill-graph';
    const skill_data = dashboard_data.skill_data;

    useEffect(() => {
        if (skill_data) {
            draw();
        }
    }, [skill_data]);
    useEffect(() => {
        const new_title = getPracticeBasedTitle(dashboard).skill;
        if (title !== new_title) {
            setTitle(new_title);
        }
    }, [dashboard]);

    function getPointWidth() {
        const n = get(skill_data, 'categories', []).length;
        return Math.round(200 / n);
    }

    function draw() {
        const graph = {
            chart: {
                type: 'bar',
                marginLeft: 230,
                height: 500
            },
            // title: {
            //     text: getPracticeBasedTitle(dashboard).skill,
            //     style: {
            //         fontWeight: 'bolder',
            //         fontSize: '18px'
            //     }
            // },
            title: null,
            xAxis: {
                categories: skill_data.categories,
                labels: {
                    style: {}
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Student Achievement'
                },
                labels: {
                    format: '{text}%'
                }
            },
            tooltip: {
                pointFormat: '<span>{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
                shared: true
            },
            plotOptions: {
                bar: {
                    stacking: 'percent',
                    maxPointWidth: 60,
                    pointWidth: getPointWidth()
                },
                series: {
                    stacking: 'normal'
                }
            },
            series: skill_data.series,
            legend: {
                enabled: true,
                reversed: true
            },
            credits: {
                enabled: false
            }
        }

        if (printable) {
            graph.tooltip.enabled = false;
        }

        Highcharts.chart(graph_id, graph)
    }

    function renderTitle() {
        if (me.is_dashboard_super_admin) {
            return (
                <InlineEdit
                    activeClassName="pam-chart-title-input"
                    text={title}
                    paramName="title"
                    change={prop => setTitle(prop.title)}
                    minLength={1}
                    maxLength={500}
                    className='pam-chart-title'
                    staticElement='div'
                    withIcon={false}
                />
            );
        }

        return (
            <div className='pam-chart-title'>{title}</div>
        );
    }

    if (skill_data === undefined || !me) {
        return null;
    }

    return (
        <div>
            <div className="pam-component">
                {renderTitle()}
                <div id={graph_id}/>
            </div>
        </div>
    );
}
